var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnExpected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 19,
    viewBox: "0 0 40 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.293701,
    width: 40,
    height: 18.4127,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4196_13523",
    transform: "scale(0.015873 0.0344828)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4196_13523",
    width: 63,
    height: 29,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAdCAYAAAAdO7TiAAAACXBIWXMAAAsSAAALEgHS3X78AAACf0lEQVRYheVZzY7SUBT+LAZxEKhhxGQSowuNxjQZ3kB8AYe9G30C2bjXJ3Dc6Y6tO/QJ5gFcMEkXLiSw4G+ITQtYQ0gazLlzLil/M8ykpYV+SVNIb3PPd885373n9MZkMsEaUAHkARTWGRwwqnw1LjPj5iXPiWwJwNEWkJ7HKYBjAOVVA1Z5njxdAfBiU5b6CFqENxwNM1CWzJnnkNkF4oRDACe8ADOY93yeB2YCMdN/vHWngZu8yqHx0GsTfvwx0R6P1x6fisXwav+uuHuMPuuYSAG34H3wg/iX9hm+ts+u/N7P4V98evzIa3MyLIJi15I5T7O883omMInr4MQa+GEOWMtmyC+IwY6j5CZfjBh5cW6R5A+DtSUQFBTe3iIJhbe4KKKw7IQXCdi2va90Op29KJIfjUa/FcMw/oXAlo3Dtu1nIuwHA98OFKGE4zjE+ReRbwyHw0iRZ75VRdO0BnmeViNMuON9UTNFr9ejn5YIe8dxvne7XV8men3/3rWIvH9w4Is9hmFgPB73NU2ryqquYprmUSqVQjqd9nSyl2oa354/uXJJ+3Tvtqd24FzhpdepSzUtaenPcavVysTjcSQSCU8nPbgVF1eQoLRuNpsyval8Pz/ba5pmUaVDD+r1+s6pP3m8VquJO4DPpHOYb2Ppul6RFU82m0Uul0PMR+HZBCjMKc/Z49TMLLCzF8ir3MMTVR4RJw1QVRXJZHJrCJOHTdOEZVnuXazPxKdd3IXWNS9AeVmvnrQgzJFARDm050EeL8pwl1j5xUbX9RILw7Z3cj+SmMtQd+PCz1UcBUVuc21TH/+Uo7e8jLTEut/qBHRdp8ZHmOt/y53TFwLAf7ok8x/bBDJvAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnExpected);
export default __webpack_public_path__ + "static/media/btnExpected.03dd06561b4f9896c5fca53a2917c284.svg";
export { ForwardRef as ReactComponent };